export const FILTER_EQUIPMENTS = 'FILTER_EQUIPMENTS';
